import { Device } from '@capacitor/device';
import { CapacitorSwipeBackPlugin } from 'capacitor-swipe-back-plugin';

export const enableSwipeBack = async (): Promise<void> => {
  try {
    const info = await Device.getInfo();
    if (info?.platform === 'web') {
      return;
    }
    await CapacitorSwipeBackPlugin.enable();
  } catch (e) {
    return;
  }
};
